<template>
  <RouterView v-if="event?.id" :event="event" :event-loading="loading" :kiosk-id="props.kioskId" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useEventBySlugQuery } from '@/gql/myomr'

const props = defineProps<{
  eventSlug: string
  kioskId: string
}>()

const { result, loading } = useEventBySlugQuery(() => ({ slug: props.eventSlug }))
const event = computed(() => result.value?.eventBySlug)
</script>
